<template>
  <v-layout align-center justify-center column fill-height>
    <v-card
      max-width="420"
      width="100%"
      flat
      style="border-radius: 8px !important"
      class="mt-3 mb-10 ma-5 pa-3"
    >
      <v-card-title class="font-weight-bold green--text text--darken-4"
        >Inscrição {{aprendiz_industrial ? " Aprendiz Industrial" : ""}}</v-card-title
      >
      <v-card-subtitle>Informe seus dados para continuar</v-card-subtitle>

      <v-card-text class="pt-2">
        <v-form ref="form">
          <v-text-field
            label="CPF"
            v-mask="'###########'"
            class="mb-2"
            v-model="acesso.cpf"
            :rules="cpf_rules"
            required
          ></v-text-field>
          <v-text-field
            label="Data de nascimento"
            type="date"
            class="mt-2"
            v-model="acesso.dtnasc"
            :rules="dtnasc_rules"
          ></v-text-field>
        </v-form>
        <v-row class="mt-2">
          <v-col cols="12">
            <v-btn
              color="green lighten-4"
              class="font-weight-bold subtitle-1 green--text text--darken-4"
              depressed
              rounded
              block
              style="font-family: Poppins !important"
              min-height="45"
              @click="continuar()"
              :loading="loading"
              >Continuar</v-btn
            >
          </v-col>
        </v-row>

        <modal-sem-acesso />
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ModalSemAcesso from "./ModalSemAcesso.vue";

export default {
  components: { ModalSemAcesso },
  computed: mapState(["acesso", "aprendiz_industrial"]),
  data: () => ({
    loading: false,
    dtnasc: "",
    cpf: "",
    cpf_rules: [(v) => v.length == 11 || "Informe corretamente seu cpf"],
    dtnasc_rules: [(v) => !!v || "Informe sua data de nascimento"],
  }),
  methods: {
    ...mapActions(["getInscricaoCandidato"]),
    async continuar() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        if (this.aprendiz_industrial) {
          this.acesso.tipo = "aprendiz-industrial";
        }

        await this.getInscricaoCandidato()
          .then((res) => {
            if (res.data.success) {
              sessionStorage.setItem("candidato", JSON.stringify(this.acesso));
              this.$router.push("/inscricao");
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => this.$toasted.error(e));

        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>